<template>
  <div class="refund-detail bgf6">
    <div :class="['detail', data.auditStatus === 2 ? 'info' : data.auditStatus === 1 ? 'primary' : 'cancel' ]">
      <img class="detail-tips-img" src="../../static/images/refund/img_sqtk@2x.png" alt="">
      <div class="detail-content">
        <div class="icm-title">
          <div class="prefix-icon"><img class="icon-img" src="../../static/images/refund/icon_tk_ks.png" alt="" srcset=""></div>
          <div class="label-content">{{data.batchName}}</div>
        </div>
        <div class="icm-content">
          <div class="content-left">{{data.specialtyName}}({{data.gradeName}})</div>
          <div class="content-right">
            ¥{{Number(data.refundFee || 0).toFixed(2)}}
          </div>
        </div>
        <div class="icm-status">
          <span v-if="data.auditStatus === 2">已退款&nbsp;&nbsp;&nbsp;¥{{Number(data.refundFee || 0).toFixed(2)}}</span>
          <span v-else-if="data.auditStatus === 1">待退款&nbsp;&nbsp;&nbsp;¥{{Number(data.refundFee || 0).toFixed(2)}}</span>
          <span v-else>退款审核不通过</span>
        </div>
      </div>
    </div>
    <div class="icm-list">
      <div style="color: #212B36; font-size: 0.48rem; font-weight: bold;">
        <div style="font-family: 'SourceHanSerifCN-Bold';">退款历史</div>
      </div>
      <div class="card" v-for="(item, index) in historyOrderList" :key="index">
        <img v-if="item.isApplyed === 1" src="../../static/images/refund/img_gr@2x.png" class="img-tips" alt="" srcset="">
        <img v-else src="../../static/images/refund/img_xt@2x.png" class="img-tips" alt="" srcset="">
        <div class="filed">
          <div class="label">退款原因</div>
          <div class="value">{{item.refundReason}}</div>
        </div>
         <div class="filed">
          <div class="label">申请时间</div>
          <div class="value">{{$moment(item.addTime).format('YYYY.MM.DD HH:mm')}}</div>
        </div>
        <div class="filed">
          <div class="label">退款编号</div>
          <div class="value">{{item.refundTradeNo}}</div>
        </div>
        <div class="filed" v-if="item.auditStatus === 2">
          <div class="label">退款成功</div>
          <div class="value">{{$moment(item.updateTime || item.addTime).format('YYYY.MM.DD HH:mm')}}</div>
        </div>
        <div class="filed" v-if="item.auditStatus === 3">
          <div class="label">退款驳回</div>
          <div class="value">{{item.unpassReason}}</div>
        </div>
      </div>
    </div>
    <div class="operation" style="width: calc(100% - 1.1rem); z-index: 1; margin: 0 0.55rem; bottom: 0.5rem; position: fixed; border: none;text-align: center" v-if="data.auditStatus !== 2">
      <van-button plain type="info" style="margin-right: 0.427rem; width: calc(50% - 0.746rem);" @click="handleClick(1)">撤销申请</van-button>
      <van-button plain type="info" style="width: calc(50% - 0.746rem);" @click="handleClick(2)">修改申请</van-button>
    </div>
  </div>
</template>
<script>
// import refundData from '../../mock/refund'
import SelectPick from "../components/select-pick"
import { Field, Button, Form, Toast, Empty, Dialog } from 'vant'
// import { expressCompanys } from '../../utils/expressJson'

export default {
  components: {
    [SelectPick.name]: SelectPick,
    [Field.name]: Field,
    [Button.name]: Button,
    [Form.name]: Form,
    [Empty.name]: Empty
  },
  data () {
    return {
      data: {},
      orderId: '',
      empty: true,
      refundStatus: 1, // 1 已经退款 2 退款不通过 3 待退款
      historyOrderList: []
    }
  },
  created () {
    this.orderId = this.$route.query.orderId
    this.getDetail(this.orderId)
  },
  methods: {
    // 获取详细信息
    async getDetail (orderId) {
      let { data } = (await this.$HTTP.ApiRefund.refundDetailGet(orderId)) || {}
      // let { data } = refundData.refundDetail
      this.data = data
      let historyOrderList = this.data.historyOrderList || []
      historyOrderList.unshift({
        refundOrderId: this.data.refundOrderId,
        refundReason: this.data.refundReason,
        refundTradeNo: this.data.refundTradeNo,
        unpassReason: this.data.unpassReason,
        updateTime: this.data.updateTime,
        addTime: this.data.addTime,
        auditStatus: this.data.auditStatus,
        isApplyed: this.data.isApplyed
      }) 
      this.historyOrderList = historyOrderList
      // this.form = data
    },

    // 按钮点击 type { 1: 撤销申请， 2: 修改申请}
    handleClick (type) {
      if (type === 1) {
        Dialog.confirm({
          title: '撤销退款',
          message: '是否确认撤销退款申请？',
        }).then(() => {
          // on confirm
          this.cancelRefund()
        })
        .catch(() => {
          // on cancel
        });
      } else if(type === 2) {
        this.$router.push({
          path: '/refund/refund-edit',
          query: {
            type: this.data.auditStatus === 3 ? 1 : 2,
            orderId: this.data.examOrderId
          }
        }) 
      }
    },

    // 撤销付款申请
    async cancelRefund () {
      await this.$HTTP.ApiRefund.cancelRefundGet(this.data.refundOrderId)
      Toast('撤销退款成功')
      setTimeout(() => {
        this.$AppMethod.goBackNative()
      }, 1000)
    }
  }
}
</script>
<style lang="less" scoped>
.refund-detail {
  padding-bottom: 60px;
  .empty {
    margin-top: 160px/2;
  }
}
.detail {
  position: relative;
  background-color: #77573A;
  padding: 48px/2 56px/2;
  color: #F8E7D2;
  .detail-tips-img {
    position: absolute;
    top: 0;
    right: 0;
    width: 300px/2;
  }
  .icm-title {
    display: flex;
    font-size: 28px/2;
    margin-top: 10px/2;
    line-height: 40px/2;
    font-family: 'SourceHanSerifCN-Regular';

    .prefix-icon {
      margin-right: 8px/2;
      .icon-img {
        width: 32px/2;
        vertical-align: middle;
      }
    }
    .label-content {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      padding-right: 60px/2;
    }
  }

  .icm-content {
    display: flex;
    margin: 24px/2 0 0;
    justify-content: space-between;
    line-height: 58px/2;
    font-weight: bold;
    font-size: 40px/2;
    font-family: 'SourceHanSerifCN-Bold';
  }

  .icm-status {
    margin-top: 48px/2;
    padding: 34px/2;
    border-radius: 10px/2;
    text-align: center;
    background-color: #917458;
    font-weight: bold;
    font-size: 48px/2;
    line-height: 70px/2;
    font-family: 'SourceHanSerifCN-Bold';
  }

  &.info {
    background-color: #AA381E;
    .icm-status {
      background-color: #BA5B42;
    }
  }

  &.cancel {
    background-color: #003788;
    .icm-status {
      background-color: #325A97;
    }
  }

  &.primary {
    background-color: #77573A;
    .icm-status {
      background-color: #917458;
    }
  }
}

.icm-list {
  margin: 48px/2;
  .card {
    margin-top: 32px/2;
    background-color: #ffffff;
    padding: 32px/2;
    border-radius: 10px/2;
    opacity: 1;
    position: relative;
    .img-tips {
      position: absolute;
      width: 40px;
      right: 0;
      top: 0;
    }

    .filed {
      min-height: 72px/2;
      line-height: 72px/2;
      display: flex;
      font-size: 28px/2;
      .label {
        width: 168/2px;
        // white-space: nowrap;
        // overflow: hidden;
        // text-overflow: ellipsis;
        font-weight: bold;
        color: #908581;
        font-family: 'SourceHanSerifCN-Bold';
      }
      .value {
        flex: 1;
        // white-space: nowrap;
        // overflow: hidden;
        // text-overflow: ellipsis;
        word-break: break-all;
        font-family: 'SourceHanSerifCN-Medium';
        color: #260E09;
        font-weight: 500;
      }
    }
  }
}
</style>